module.exports = __webpack_public_path__ + "img/brand (13).ffa42b6d.svg";